import styled from 'styled-components';
import Icon from '../Icon';

export const StyledDisclaimer = styled.div`
  align-items: center;
  padding: 12px;
  background: ${({ theme }) => theme.COLORS.BASE};
  border: 1px solid transparent;
  border-left: 9px solid transparent;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  border-color: ${({ theme }) => theme.COLORS.INFO};
  border-color: ${props => props.color};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  display: flex;
  flex-direction: row;
  text-align: left;
`;

export const StyledInfoIcon = styled(Icon)`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  flex: 0 0 auto;
`;

export default {};
